// Shared by report summaries and Mesh AI, including restored/queued turns.
export const AI_QUOTA_ERRORS = {
  tr: {
    QUOTA_EXCEEDED: 'AI kullanım kotanız yetersiz.',
    LLM_INSUFFICIENT_QUOTA: 'AI kullanım kotanız yetersiz.',
    TENANT_QUOTA_EXCEEDED: 'Kurumunuzun AI token kotası bu analiz için yetersiz. Kurum yöneticinizden ek kota talep edin.',
    TENANT_QUOTA_UNAVAILABLE: 'Kurumunuzun AI kotası doğrulanamadı. Lütfen tekrar deneyin.',
    LLM_PROVIDER_QUOTA: 'AI servisinin kullanım kredisi dolmuş. Kurum yöneticinize bildirin.',
  },
  en: {
    QUOTA_EXCEEDED: 'Insufficient AI quota.',
    LLM_INSUFFICIENT_QUOTA: 'Insufficient AI quota.',
    TENANT_QUOTA_EXCEEDED: 'Your organization has insufficient AI token quota for this analysis. Contact your administrator.',
    TENANT_QUOTA_UNAVAILABLE: 'Your organization’s AI quota could not be verified. Please retry.',
    LLM_PROVIDER_QUOTA: 'AI service credits are depleted. Contact your administrator.',
  },
  fr: {
    QUOTA_EXCEEDED: 'Quota IA insuffisant.',
    LLM_INSUFFICIENT_QUOTA: 'Quota IA insuffisant.',
    TENANT_QUOTA_EXCEEDED: 'Le quota de jetons IA de votre organisation est insuffisant pour cette analyse. Contactez votre administrateur.',
    TENANT_QUOTA_UNAVAILABLE: 'Le quota IA de votre organisation n’a pas pu être vérifié. Réessayez.',
    LLM_PROVIDER_QUOTA: 'Les crédits du service IA sont épuisés. Contactez votre administrateur.',
  },
};

export function aiQuotaErrorMessage(code, locale = 'tr') {
  const language = locale.startsWith('en') ? 'en' : locale.startsWith('fr') ? 'fr' : 'tr';
  return Object.prototype.hasOwnProperty.call(AI_QUOTA_ERRORS[language], code)
    ? AI_QUOTA_ERRORS[language][code]
    : null;
}
